import React, { useEffect, useState, useRef } from 'react'
import { Controller } from 'react-hook-form'
import { usersByOrg } from '@vt/apis/lib-ex/v2/users'
// import { usersByOrg } from '@vt/apis/lib/v4/users'
import {
  Modal,
  Button,
  Toast,
  CheckboxGroup,
  Input,
  Checkbox,
  FormItem,
} from '@ow/comps'
import useForm from './use-form'

const OperateGroup = function ({
  appId,
  action = 'add',
  oneLevel,
  closeModal,
  title,
  useOrg,
  open,
}) {
  const formRef = useRef(null)
  const {
    roles,
    currentOrg,
    orgOperate,
    currentOrgRoles,
    userFilter: { onSelectOrg },
  } = useOrg

  // 组织下的角色 目前没有获取到
  // const orgRoles = (parentOrg.info && parentOrg.info.roles) || []

  const {
    watch,
    reset,
    control,
    setValue,
    // getValues,
    formState: { errors },
  } = useForm(
    {
      currentOrg: currentOrg &&
        action === 'edit' && { title: currentOrg.title },
    },
    formRef
  )
  const selectRoles = watch('roles')
  // 是否重点关注主体
  const [isFocus, setIsFocus] = useState(true)
  const { orgUsersMutate } = usersByOrg(appId)

  useEffect(() => {
    // 对角色的处理
    if (currentOrg) {
      const { info = {} } = currentOrg
      if (currentOrg && action !== 'add') {
        setIsFocus(info.isFocus)
      }
      // 如果是编辑操作，角色roles为全部角色
      // if (action !== 'add') {
      //   setRoles(allRoles)
      // }
      // 如果是新增下级组织，角色roles为父级包含的组织
      // if (action === 'add' && !oneLevel) {
      //   setRoles(
      //     roles.filter((v) => {
      //       return (info.roles || []).includes(v.value) === true
      //     })
      //   )
      // }
    }
  }, [currentOrg])

  useEffect(() => {
    if (open) {
      if (action === 'edit') {
        setValue(
          'roles',
          (currentOrgRoles || []).map((x) => x.value)
        )
        setValue('title', currentOrg.extData.label)
      } else {
        setValue('roles', [])
        setValue('title', '')
      }
    }
  }, [open])

  const onSubmit = () => {
    const data = formRef.current.getValues()
    formRef.current.trigger().then((tr) => {
      if (tr) {
        const params = {
          ...data,
          isFocus,
          roles: data.roles || [],
        }

        if (action === 'add') {
          orgOperate
            .addOrg(
              {
                ...params,
                parentId: oneLevel ? null : currentOrg.key,
              },
              () => {
                reset()
                if (closeModal) {
                  closeModal()
                }
              }
            )
            .catch((error) => {
              if (error.response.data.msg) {
                Toast.error({
                  title: '操作失败',
                  description: error.response.data.msg,
                })
              }
            })
        } else {
          orgOperate.updateOrg({ ...params, id: currentOrg.key }, () => {
            reset()
            orgUsersMutate()
            onSelectOrg(null, { node: currentOrg })
            if (closeModal) {
              closeModal()
            }
          })
        }
      }
    })
  }

  return (
    <Modal
      open={open}
      title={title}
      size="md"
      onClose={closeModal}
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={() => {
        return (
          <div className="-full flex flex-row justify-end">
            <Button onClick={closeModal} className="mr-2" stroke>
              取消
            </Button>
            <Button type="primary" onClick={onSubmit}>
              确定
            </Button>
          </div>
        )
      }}
    >
      <div className="flex flex-col -mt-2 mb-20">
        <FormItem
          required
          label="组织名称"
          error={
            (errors.title && errors.title.type === 'required' && '必填项') ||
            (errors.title &&
              errors.title.type === 'maxLength' &&
              '组织名称不能超过40个字符')
          }
        >
          <Controller
            render={({ field }) => {
              return (
                <Input
                  {...field}
                  placeholder="请输入"
                  className="input form-input w-full border flex-1 mt-2"
                  onChange={(e) => {
                    field.onChange(e)
                  }}
                />
              )
            }}
            name="title"
            rules={{ required: true, maxLength: 40 }}
            control={control}
            defaultValue={
              currentOrg && action === 'edit' ? currentOrg.extData.label : ''
            }
          />
        </FormItem>

        {roles.length > 0 && (
          <FormItem
            className="mt-2"
            required
            label="包含角色"
            error={errors.roles && errors.roles.type === 'required' && '必填项'}
          >
            {roles.length > 1 && (
              <Checkbox
                name="roleIds"
                label="全选"
                value="all"
                onChange={(e) => {
                  if (e.target.checked) {
                    setValue(
                      'roles',
                      roles.map((x) => {
                        return x.value
                      })
                    )
                  } else {
                    setValue('roles', [])
                  }
                }}
                checked={selectRoles && selectRoles.length === roles.length}
              />
            )}
            <Controller
              render={({ field }) => {
                return (
                  <CheckboxGroup
                    options={roles || []}
                    checkedValues={field.value}
                    onChange={(e) => {
                      field.onChange(e)
                    }}
                  />
                )
              }}
              name="roles"
              rules={{ required: true }}
              control={control}
            />
          </FormItem>
        )}
      </div>
    </Modal>
  )
}

export default OperateGroup
